import { gql } from "@medbillai/generated-graphql-types";

export const resolveInviteTokenQuery = gql(/* GraphQL */ `
  query ResolveInviteToken($inviteToken: String!) {
    resolveInviteToken(inviteToken: $inviteToken) {
        ... on AvailableInviteToken {
            __typename
            partner {
                name
                slug
            }
        }
        ... on RedeemedInviteToken {
            __typename
            partner {
                name
                slug
            }
        }
    }
  }
`);
